export const DOSSIER_DETAILS_QUERY_KEY = "details";
